import { render } from "./TestCon.vue?vue&type=template&id=d05a79ae"
import script from "./TestCon.vue?vue&type=script&lang=js"
export * from "./TestCon.vue?vue&type=script&lang=js"

import exportComponent from "D:\\服务器\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__